import { TimePicker } from '@fox/atoms/src/time-picker';
import moment from 'moment';
import { FormRenderMode, QuestionStyleTypes } from '../../../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../../../form-runtime-context/form-runtime-context';
import { DataTableCustomFieldComponentArgs } from '../helpers';

export const TimeCustomField = ({ questionId, field, row, handleChange }: DataTableCustomFieldComponentArgs) => {
	const { formRenderMode } = useFormRuntimeContext();

	let val: Date | null = null;
	const splitTime = row?.[field.fieldId]?.split(':');
	if (splitTime?.length === 2) {
		const hours = Number(splitTime[0]);
		const minutes = Number(splitTime[1]);
		val = moment().hours(hours).minutes(minutes).toDate();
	}

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, questionId);

	return (
		<TimePicker
			value={val}
			onChange={e => {
				if (formRenderMode === FormRenderMode.design) return;

				handleChange(e ? moment(e).format('HH:mm') : '', row.rowId, field.fieldId);
			}}
			sx={{
				'.MuiInputBase-root': {
					color,
					fontSize,
					fontStyle,
					fontFamily,
					textDecoration,
					fontWeight
				},
				'input:focus, textarea': {
					border: '0',
					boxShadow: 'none'
				}
			}}
		/>
	);
};
